var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"wx-code",attrs:{"visible":_vm.viewIsReady,"title":_vm.title,"width":"420px"},on:{"close":_vm.handleClose}},[(!!_vm.image)?_c('img',{attrs:{"src":_vm.image,"alt":"二维码"}}):_vm._e(),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleClose}},[_vm._v("确定")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }